// extracted by mini-css-extract-plugin
export default {"content":"client-item_content__IT6J+","contentImg":"client-item_contentImg__yU3G6","contentText":"client-item_contentText__fhgK+","contentIcon":"client-item_contentIcon__cV4Yv"};